import { useState } from "react";
import { SectionHeading } from "@/components/Atoms";
import { AscensionForge } from "@/components/AscensionForge";
import { SingleAcquireModal } from "@/components/SingleAcquireModal";

export default function AscendPage() {
  const [ascendResult, setAscendResult] = useState(null);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10" data-testid="ascend-page">
      <SectionHeading
        eyebrow="Forge"
        title="ASCEND"
        description="Sacrifice 10 cards of one rarity to forge a brand-new card one full tier higher. The 10 are recycled back to the store."
      />

      <AscensionForge onAscended={(card) => setAscendResult(card)} />

      {ascendResult && (
        <SingleAcquireModal
          card={ascendResult}
          headline="ASCENDED"
          onClose={() => setAscendResult(null)}
        />
      )}
    </div>
  );
}
